module.exports = __webpack_public_path__ + "img/Sen_InArSo_logo_RGB_quer.4fa3b565.png";